export default __webpack_public_path__ + "static/media/about-benefits-profile-listing-page.c0dec495.jpg";